import React, { useMemo, useState } from 'react';
import {
  orderBy,
  map,
  head,
  keys,
  pick,
  size,
  flow,
  values,
  flatten
} from 'lodash/fp';
import { Table } from 'rsuite';
import { useSelector } from 'react-redux';
import {
  getAll as getGuestSummaryReport,
  getIsFetching
} from '../../../../redux/Inventory/selectors/reports/guest-summary';
import PathKeyCell from '../../../widgets/custom-cell/PathKey';
import computeTableHeight from '../../../../helpers/computeTableHeight';
import tableColumns from './columns';
import HeaderCell from '../../../widgets/custom-cell/HeaderCell';

const { Column } = Table;

export default function GuestSummaryList() {
  const [sort, setSort] = useState({ column: 'quantity', type: 'asc' });
  const searchResult = useSelector(getGuestSummaryReport);
  const isFetching = useSelector(getIsFetching);

  const handleSortColumn = (column, type) => {
    setSort({ column, type });
  };

  const resultColumns = useMemo(
    () => {
      if (!size(searchResult)) return [];
      const resultKeys = keys(head(searchResult));
      return flow(
        pick(resultKeys),
        values,
        flatten,
        orderBy('order', 'asc')
      )(tableColumns);
    },
    [searchResult]
  );

  const sortedData = orderBy(sort.column, sort.type, searchResult);

  return (
    <Table
      bordered
      cellBordered
      data={sortedData}
      loading={isFetching}
      sortColumn={sort.column}
      sortType={sort.type}
      onSortColumn={handleSortColumn}
      height={computeTableHeight(size(searchResult))}
    >
      {map(
        ({ dataKey, label, width }) => (
          <Column resizable sortable key={`column-${dataKey}`} width={width}>
            <HeaderCell>{label}</HeaderCell>
            <PathKeyCell dataKey={dataKey} />
          </Column>
        ),
        resultColumns
      )}
    </Table>
  );
}
